module.exports = __webpack_public_path__ + "img/dayiguan-icon.ad8408b1.png";